import ComboBoxDynamic from './ComboBoxDynamic'

export default ComboBoxDynamic;